/* tslint:disable */
/* eslint-disable */
/**
 * home-health-api
 * home-health-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { HchbPayorTypePage } from './HchbPayorTypePage';
import {
    HchbPayorTypePageFromJSON,
    HchbPayorTypePageFromJSONTyped,
    HchbPayorTypePageToJSON,
} from './HchbPayorTypePage';

/**
 * 
 * @export
 * @interface FindAllHchbPayorTypes200Response
 */
export interface FindAllHchbPayorTypes200Response {
    /**
     * 
     * @type {HchbPayorTypePage}
     * @memberof FindAllHchbPayorTypes200Response
     */
    data?: HchbPayorTypePage;
}

/**
 * Check if a given object implements the FindAllHchbPayorTypes200Response interface.
 */
export function instanceOfFindAllHchbPayorTypes200Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FindAllHchbPayorTypes200ResponseFromJSON(json: any): FindAllHchbPayorTypes200Response {
    return FindAllHchbPayorTypes200ResponseFromJSONTyped(json, false);
}

export function FindAllHchbPayorTypes200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindAllHchbPayorTypes200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : HchbPayorTypePageFromJSON(json['data']),
    };
}

export function FindAllHchbPayorTypes200ResponseToJSON(value?: FindAllHchbPayorTypes200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': HchbPayorTypePageToJSON(value.data),
    };
}

